export default __webpack_public_path__ + "static/media/Zoom_In.786ec377.svg";